module.exports = __webpack_public_path__ + "img/15_3.5a1e7b56.png";